import { ConfigurationPostingFrameService_postingFrameServiceGetValidPostingTypes } from '@festina/life-general-types/life/hooks/ConfigurationPostingFrameService_postingFrameServiceGetValidPostingTypes'

export const useFetchPostingFramePostingTypes =
  ConfigurationPostingFrameService_postingFrameServiceGetValidPostingTypes.useSuspenseQuery
